import { render, staticRenderFns } from "./T1SzukajContent.vue?vue&type=template&id=5554e8f6&"
import script from "./T1SzukajContent.vue?vue&type=script&lang=js&"
export * from "./T1SzukajContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports